import React, { useState } from 'react'
import { Map } from 'immutable'
import { COURSE_STATE_IN_PROGRESS } from '../../../services/detail/index'
import Button, { TYPES } from '../../Button/index'
import { getTruncatedText } from '../utils'

const TRUNCATED_DESCRIPTION_APPROX_SIZE = 150

/**
   * Course detail page progress bar component
 * @param {Object} props - The props
 * @param {Map} props.moduleData - The course module data
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseProgressBar
 */

const DetailPageV3CourseModuleDescription = (props) => {
  const {
    moduleData = Map(),
    staticText,
  } = props

  const description = moduleData.get('description') || ''
  const moduleState = moduleData.getIn(['courseModuleProgress', 'state'])
  const shouldTruncate = description.length > TRUNCATED_DESCRIPTION_APPROX_SIZE
  const truncatedDescription = shouldTruncate
    ? getTruncatedText(description, TRUNCATED_DESCRIPTION_APPROX_SIZE)
    : description

  const [expanded, setExpanded] = useState(moduleState === COURSE_STATE_IN_PROGRESS)

  if (expanded || !shouldTruncate) {
    return (
      <p className="detail-page-v3__course-module-description">
        {moduleData.get('description')}
      </p>
    )
  }

  return (
    <p className="detail-page-v3__course-module-description">
      {truncatedDescription}
      <Button
        className="detail-page-v3__more-info-button"
        type={TYPES.LINK}
        onClick={() => setExpanded(true)}
      >
        {staticText.get('moreInfo')}
      </Button>
    </p>
  )
}

export default DetailPageV3CourseModuleDescription
